
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import { IHandhole } from '@rfm/shared-interfaces';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HandholeService } from '../../../../../shared/services/fiber-management/handhole.service.mjs';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-handhole-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputSwitchModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
  ],
  templateUrl: './handhole-edit.component.html',
  styleUrls: ['./handhole-edit.component.scss'],
})
export class HandholeEditComponent implements OnInit {
    @Input() displayModal: boolean = false;
    @Input() order: Order | null = null;
    @Output() closeModal = new EventEmitter<void>();
  handholeForm!: FormGroup;
  isLoading = true;
  handholeId!: string;
  taskForm = new FormGroup({
    serviceName: new FormControl(''),
    clientName: new FormControl('Kathryn Murphy'),
    dueDate: new FormControl(new Date()),
    status: new FormControl('Paid'),
    items: new FormControl(2),
    total: new FormControl('$0'),
    orderId: new FormControl('#0145'),
  });
  clientPhoto = 'https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'; // Replace with actual image URL

  statusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ];

  itemOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
  ];
  saveChanges() {
    console.log('Saving:', this.order);
    this.closeModal.emit();
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private handholeService: HandholeService
  ) {}

  ngOnInit(): void {
    this.handholeId = this.route.snapshot.paramMap.get('id')!;
    if (this.handholeId) {
      this.loadHandhole(this.handholeId);
    }
  }

  loadHandhole(id: string): void {
    this.handholeService.get(id)
      .then((response) => {
        const handhole: IHandhole | null = response?.data ?? null;
        if (!handhole) {
          console.error('Handhole not found');
          this.isLoading = false;
          return;
        }
        this.initializeForm(handhole);
        this.isLoading = false;
      })
      .catch((error) => {
        console.error('Error loading handhole:', error);
        this.isLoading = false;
      });
  }

  initializeForm(handhole: IHandhole): void {
    this.handholeForm = this.fb.group({
      size: [handhole.size, Validators.required],
      status: [handhole.status, Validators.required],
      coordinates: [handhole.overlay_data, Validators.required],
      is_4x4: [handhole.is_4x4, Validators.required],
      is_vdot: [handhole.is_vdot, Validators.required],
    });
  }

  onSubmit(): void {
    if (this.handholeForm.valid) {
      const updatedHandhole: IHandhole = { id: this.handholeId, ...this.handholeForm.value };
      this.isLoading = true;

      this.handholeService.update(updatedHandhole)
        .then(() => {
          console.log('Handhole updated successfully');
          this.router.navigate(['/handhole/list']);
        })
        .catch((error) => {
          console.error('Error updating handhole:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
